import { OpsSummary } from '@/domain/ops/interfaces/ops';
import { opsRepository } from '@/domain/ops/repositories/opsRepository';
import { logger } from '@/infrastructure/persistence/managers/LoggerManager';
import { createStore } from '@/lib/zustand';

interface HomeState {
  /** The portfolio numbers of the day, read from the same endpoint the Carteira reads. */
  resumo: OpsSummary | null;
  resumoLoading: boolean;
  /** The last load failed: the blocks say so instead of showing zeroes. */
  resumoFailed: boolean;
  /** Never throws: every block reads `resumoFailed` and offers the retry. */
  loadResumo: () => Promise<void>;
}

/**
 * The summary rides along with ANY page of `GET ops` (the API computes it over the whole
 * portfolio, never over the page), so the home screen asks for the smallest page there is.
 */
const RESUMO_PAGE_SIZE = 1;

export const homeStore = createStore<HomeState>((set) => ({
  resumo: null,
  resumoLoading: false,
  resumoFailed: false,

  loadResumo: async () => {
    set({ resumoLoading: true });
    try {
      const result = await opsRepository.list({ page: 1, limit: RESUMO_PAGE_SIZE });
      set({ resumo: result.summary ?? null, resumoFailed: false });
    } catch (error) {
      logger.error('[homeStore] failed to load resumo da carteira', error);
      set({ resumoFailed: true });
    } finally {
      set({ resumoLoading: false });
    }
  },
}));
